import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = { class: "sidebar" };
const _hoisted_2 = ["aria-label", "title"];
const _hoisted_3 = { class: "sidebar-scroll" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = ["aria-expanded"];
const _hoisted_6 = {
    class: "chevron",
    "aria-hidden": "true"
};
const _hoisted_7 = {
    key: 0,
    class: "nested"
};
const _hoisted_8 = ["aria-expanded"];
const _hoisted_9 = {
    class: "chevron",
    "aria-hidden": "true"
};
const _hoisted_10 = {
    key: 0,
    class: "nested"
};
const _hoisted_11 = ["aria-expanded"];
const _hoisted_12 = {
    class: "chevron",
    "aria-hidden": "true"
};
const _hoisted_13 = {
    key: 0,
    class: "nested"
};
const _hoisted_14 = ["aria-expanded"];
const _hoisted_15 = {
    class: "chevron",
    "aria-hidden": "true"
};
const _hoisted_16 = {
    key: 0,
    class: "nested"
};
const _hoisted_17 = { key: 3 };
const _hoisted_18 = {
    key: 0,
    class: "topbar"
};
const _hoisted_19 = {
    key: 0,
    class: "badge"
};
const _hoisted_20 = {
    key: 1,
    class: "badge"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = {
    key: 1,
    class: "avatar-mini placeholder"
};
const _hoisted_23 = { class: "profile-name" };
const _hoisted_24 = {
    key: 3,
    class: "profile-pill",
    title: "Profile"
};
const _hoisted_25 = ["src"];
const _hoisted_26 = {
    key: 1,
    class: "avatar-mini placeholder"
};
const _hoisted_27 = { class: "profile-name" };
const _hoisted_28 = { class: "content" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_ChevronRight = _resolveComponent("ChevronRight");
    const _component_ChevronLeft = _resolveComponent("ChevronLeft");
    const _component_Gauge = _resolveComponent("Gauge");
    const _component_router_link = _resolveComponent("router-link");
    const _component_ClipboardPenLine = _resolveComponent("ClipboardPenLine");
    const _component_ChevronUp = _resolveComponent("ChevronUp");
    const _component_ChevronDown = _resolveComponent("ChevronDown");
    const _component_Plus = _resolveComponent("Plus");
    const _component_CircleQuestionMark = _resolveComponent("CircleQuestionMark");
    const _component_ClipboardList = _resolveComponent("ClipboardList");
    const _component_Hammer = _resolveComponent("Hammer");
    const _component_Shapes = _resolveComponent("Shapes");
    const _component_Users = _resolveComponent("Users");
    const _component_Building2 = _resolveComponent("Building2");
    const _component_Truck = _resolveComponent("Truck");
    const _component_Printer = _resolveComponent("Printer");
    const _component_Tickets = _resolveComponent("Tickets");
    const _component_Package = _resolveComponent("Package");
    const _component_PackagePlus = _resolveComponent("PackagePlus");
    const _component_LayoutGrid = _resolveComponent("LayoutGrid");
    const _component_PackageCheck = _resolveComponent("PackageCheck");
    const _component_ChartNoAxesCombined = _resolveComponent("ChartNoAxesCombined");
    const _component_CircleArrowLeft = _resolveComponent("CircleArrowLeft");
    const _component_ShoppingCart = _resolveComponent("ShoppingCart");
    const _component_Bell = _resolveComponent("Bell");
    const _component_router_view = _resolveComponent("router-view");
    return (_openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["admin-layout", { 'sidebar-collapsed': _ctx.sidebarCollapsed }])
    }, [
        _createElementVNode("nav", _hoisted_1, [
            _createElementVNode("button", {
                type: "button",
                class: "collapse-toggle",
                "aria-label": _ctx.sidebarCollapsed ? 'Expand navigation' : 'Collapse navigation',
                title: _ctx.sidebarCollapsed ? 'Expand navigation' : 'Collapse navigation',
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.sidebarCollapsed = !_ctx.sidebarCollapsed))
            }, [
                (_ctx.sidebarCollapsed)
                    ? (_openBlock(), _createBlock(_component_ChevronRight, { key: 0 }))
                    : (_openBlock(), _createBlock(_component_ChevronLeft, { key: 1 }))
            ], 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, [
                _cache[25] || (_cache[25] = _createElementVNode("img", {
                    src: "/logo.png",
                    alt: "Logo",
                    class: "logo"
                }, null, -1)),
                _createElementVNode("ul", null, [
                    (!_ctx.loading && (_ctx.role === 'admin' || _ctx.role === 'client'))
                        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
                            _createVNode(_component_router_link, {
                                to: "/app/dashboard",
                                title: "Dashboard"
                            }, {
                                default: _withCtx(() => [
                                    _createVNode(_component_Gauge, { class: "icon" }),
                                    _cache[5] || (_cache[5] = _createTextVNode(" Dashboard", -1))
                                ]),
                                _: 1,
                                __: [5]
                            })
                        ]))
                        : _createCommentVNode("", true),
                    (!_ctx.loading && _ctx.role === 'client')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "orders-header",
                                    title: "Orders",
                                    "aria-expanded": _ctx.ordersOpen,
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.toggleOrders && _ctx.toggleOrders(...args)))
                                }, [
                                    _createVNode(_component_ClipboardPenLine, { class: "icon" }),
                                    _cache[6] || (_cache[6] = _createElementVNode("span", null, "Orders", -1)),
                                    _createElementVNode("span", _hoisted_6, [
                                        (_ctx.ordersOpen)
                                            ? (_openBlock(), _createBlock(_component_ChevronUp, { key: 0 }))
                                            : (_openBlock(), _createBlock(_component_ChevronDown, { key: 1 }))
                                    ])
                                ], 8, _hoisted_5),
                                (_ctx.ordersOpen)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/orders/new",
                                                title: "New Order"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_Plus, { class: "icon" }),
                                                    _cache[7] || (_cache[7] = _createTextVNode(" New Order", -1))
                                                ]),
                                                _: 1,
                                                __: [7]
                                            })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                                _createVNode(_component_router_link, {
                                    to: "/app/help",
                                    title: "Help"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_CircleQuestionMark, { class: "icon" }),
                                        _cache[8] || (_cache[8] = _createTextVNode(" Help", -1))
                                    ]),
                                    _: 1,
                                    __: [8]
                                })
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    (!_ctx.loading && _ctx.role === 'admin')
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                            _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "orders-header",
                                    title: "Orders",
                                    "aria-expanded": _ctx.ordersOpen,
                                    onClick: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.toggleOrders && _ctx.toggleOrders(...args)))
                                }, [
                                    _createVNode(_component_ClipboardPenLine, { class: "icon" }),
                                    _cache[9] || (_cache[9] = _createElementVNode("span", null, "Orders", -1)),
                                    _createElementVNode("span", _hoisted_9, [
                                        (_ctx.ordersOpen)
                                            ? (_openBlock(), _createBlock(_component_ChevronUp, { key: 0 }))
                                            : (_openBlock(), _createBlock(_component_ChevronDown, { key: 1 }))
                                    ])
                                ], 8, _hoisted_8),
                                (_ctx.ordersOpen)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_10, [
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/orders",
                                                title: "Manage Orders"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_ClipboardList, { class: "icon" }),
                                                    _cache[10] || (_cache[10] = _createTextVNode(" Manage Orders", -1))
                                                ]),
                                                _: 1,
                                                __: [10]
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/orders/new",
                                                title: "New Order"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_Plus, { class: "icon" }),
                                                    _cache[11] || (_cache[11] = _createTextVNode(" New Order", -1))
                                                ]),
                                                _: 1,
                                                __: [11]
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/orders/build",
                                                title: "Build Order"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_Hammer, { class: "icon" }),
                                                    _cache[12] || (_cache[12] = _createTextVNode(" Build Order", -1))
                                                ]),
                                                _: 1,
                                                __: [12]
                                            })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "manage-header",
                                    title: "Manage",
                                    "aria-expanded": _ctx.manageOpen,
                                    onClick: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_ctx.toggleManage && _ctx.toggleManage(...args)))
                                }, [
                                    _createVNode(_component_Shapes, { class: "icon" }),
                                    _cache[13] || (_cache[13] = _createElementVNode("span", null, "Manage", -1)),
                                    _createElementVNode("span", _hoisted_12, [
                                        (_ctx.manageOpen)
                                            ? (_openBlock(), _createBlock(_component_ChevronUp, { key: 0 }))
                                            : (_openBlock(), _createBlock(_component_ChevronDown, { key: 1 }))
                                    ])
                                ], 8, _hoisted_11),
                                (_ctx.manageOpen)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/manage/clients",
                                                title: "Clients"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_Users, { class: "icon" }),
                                                    _cache[14] || (_cache[14] = _createTextVNode(" Clients", -1))
                                                ]),
                                                _: 1,
                                                __: [14]
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/manage/companies",
                                                title: "Companies"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_Building2, { class: "icon" }),
                                                    _cache[15] || (_cache[15] = _createTextVNode(" Companies", -1))
                                                ]),
                                                _: 1,
                                                __: [15]
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/manage/suppliers",
                                                title: "Suppliers"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_Truck, { class: "icon" }),
                                                    _cache[16] || (_cache[16] = _createTextVNode(" Suppliers", -1))
                                                ]),
                                                _: 1,
                                                __: [16]
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/manage/printers",
                                                title: "Printers"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_Printer, { class: "icon" }),
                                                    _cache[17] || (_cache[17] = _createTextVNode(" Printers", -1))
                                                ]),
                                                _: 1,
                                                __: [17]
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/manage/tickets",
                                                title: "Tickets"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_Tickets, { class: "icon" }),
                                                    _cache[18] || (_cache[18] = _createTextVNode(" Tickets", -1))
                                                ]),
                                                _: 1,
                                                __: [18]
                                            })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "products-header",
                                    title: "Products",
                                    "aria-expanded": _ctx.productsOpen,
                                    onClick: _cache[4] || (_cache[4] =
                                        //@ts-ignore
                                        (...args) => (_ctx.toggleProducts && _ctx.toggleProducts(...args)))
                                }, [
                                    _createVNode(_component_Package, { class: "icon" }),
                                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "Products", -1)),
                                    _createElementVNode("span", _hoisted_15, [
                                        (_ctx.productsOpen)
                                            ? (_openBlock(), _createBlock(_component_ChevronUp, { key: 0 }))
                                            : (_openBlock(), _createBlock(_component_ChevronDown, { key: 1 }))
                                    ])
                                ], 8, _hoisted_14),
                                (_ctx.productsOpen)
                                    ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/products/add",
                                                title: "Add Product"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_PackagePlus, { class: "icon" }),
                                                    _cache[20] || (_cache[20] = _createTextVNode(" Add Product", -1))
                                                ]),
                                                _: 1,
                                                __: [20]
                                            })
                                        ]),
                                        _createElementVNode("li", null, [
                                            _createVNode(_component_router_link, {
                                                to: "/app/products/categories",
                                                title: "Categories"
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_LayoutGrid, { class: "icon" }),
                                                    _cache[21] || (_cache[21] = _createTextVNode(" Categories", -1))
                                                ]),
                                                _: 1,
                                                __: [21]
                                            })
                                        ])
                                    ]))
                                    : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("li", null, [
                                _createVNode(_component_router_link, {
                                    to: "/app/inventory",
                                    title: "Inventory"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_PackageCheck, { class: "icon" }),
                                        _cache[22] || (_cache[22] = _createTextVNode(" Inventory", -1))
                                    ]),
                                    _: 1,
                                    __: [22]
                                })
                            ]),
                            _createElementVNode("li", null, [
                                _createVNode(_component_router_link, {
                                    to: "/app/statistics",
                                    title: "Statistics"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_ChartNoAxesCombined, { class: "icon" }),
                                        _cache[23] || (_cache[23] = _createTextVNode(" Statistics", -1))
                                    ]),
                                    _: 1,
                                    __: [23]
                                })
                            ]),
                            _createElementVNode("li", null, [
                                _createVNode(_component_router_link, {
                                    to: "/app/help",
                                    title: "Help"
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_CircleQuestionMark, { class: "icon" }),
                                        _cache[24] || (_cache[24] = _createTextVNode(" Help", -1))
                                    ]),
                                    _: 1,
                                    __: [24]
                                })
                            ])
                        ], 64))
                        : _createCommentVNode("", true),
                    (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("li", _hoisted_17, "Checking permissions…"))
                        : _createCommentVNode("", true)
                ]),
                _createVNode(_component_router_link, {
                    to: "/",
                    class: "back-button",
                    title: "Sign Out"
                }, {
                    default: _withCtx(() => [
                        _createVNode(_component_CircleArrowLeft)
                    ]),
                    _: 1
                })
            ])
        ]),
        (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createVNode(_component_ShoppingCart, { class: "icon-sm" }),
                (_ctx.cartCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.cartCount), 1))
                    : _createCommentVNode("", true),
                _createVNode(_component_Bell, { class: "icon-sm" }),
                (_ctx.notificationsCount)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.notificationsCount), 1))
                    : _createCommentVNode("", true),
                (_ctx.currentUid)
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 2,
                        to: { name: 'UserProfile', params: { id: _ctx.currentUid } },
                        class: "profile-pill",
                        title: "Profile"
                    }, {
                        default: _withCtx(() => [
                            (_ctx.photoURL)
                                ? (_openBlock(), _createElementBlock("img", {
                                    key: 0,
                                    src: _ctx.photoURL,
                                    alt: "Profile",
                                    class: "avatar-mini"
                                }, null, 8, _hoisted_21))
                                : (_openBlock(), _createElementBlock("div", _hoisted_22)),
                            _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.displayName || 'User'), 1)
                        ]),
                        _: 1
                    }, 8, ["to"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        (_ctx.photoURL)
                            ? (_openBlock(), _createElementBlock("img", {
                                key: 0,
                                src: _ctx.photoURL,
                                alt: "Profile",
                                class: "avatar-mini"
                            }, null, 8, _hoisted_25))
                            : (_openBlock(), _createElementBlock("div", _hoisted_26)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.displayName || 'User'), 1)
                    ]))
            ]))
            : _createCommentVNode("", true),
        _createElementVNode("main", _hoisted_28, [
            _createVNode(_component_router_view)
        ])
    ], 2));
}
